<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M13.425 11.05L9.175 6.79995L10.6 5.39995L13.425 8.22495L19.1 2.57495L20.5 3.97495L13.425 11.05ZM7.5 18.5L14.45 20.4L20.4 18.55C20.3167 18.4 20.1958 18.2708 20.0375 18.1625C19.8792 18.0541 19.7 18 19.5 18H14.45C14 18 13.6417 17.9833 13.375 17.95C13.1083 17.9166 12.8333 17.85 12.55 17.75L10.225 16.975L10.775 15.025L12.8 15.7C13.0833 15.7833 13.4167 15.85 13.8 15.9C14.1833 15.95 14.75 15.9833 15.5 16C15.5 15.8166 15.4458 15.6416 15.3375 15.475C15.2292 15.3083 15.1 15.2 14.95 15.15L9.1 13H7.5V18.5ZM1.5 22V11H9.1C9.21667 11 9.33333 11.0125 9.45 11.0375C9.56667 11.0625 9.675 11.0916 9.775 11.125L15.65 13.3C16.2 13.5 16.6458 13.85 16.9875 14.35C17.3292 14.85 17.5 15.4 17.5 16H19.5C20.3333 16 21.0417 16.275 21.625 16.825C22.2083 17.375 22.5 18.1 22.5 19V20L14.5 22.5L7.5 20.55V22H1.5ZM3.5 20H5.5V13H3.5V20Z"
      :fill="fillColor"
    />
  </svg>
</template>
<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps({
  disabled: {
    type: Boolean,
    default: false,
  },
})

const fillColor = computed(() => {
  return props.disabled ? '#6C7380' : '#3D424B'
})
</script>
